
import { useState, useEffect } from 'react';
import { Shield, Crown } from 'lucide-react';
import PackageCard from './PackageCard';

interface PackageSelectionProps {
  visible: boolean;
  onPackageSelect: (packageType: 'silver' | 'gold') => void;
}

const PackageSelection = ({ visible, onPackageSelect }: PackageSelectionProps) => {
  return (
    <section className={`py-20 px-4 sm:px-6 md:px-8 transition-all duration-700 ease-in-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-blue mb-12">
          Choose Your Career Guidance Package
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Silver Package */}
          <PackageCard 
            type="silver"
            title="Silver Package"
            price="₹1,499"
            features={[
              "Complete RIASEC Career Assessment Test",
              "Personalized Holland Code Report",
              "Scientific Career Recommendations"
            ]}
            icon={<Shield className="h-8 w-8 text-gray-500" />}
            onSelect={onPackageSelect}
          />
          
          {/* Gold Package */}
          <PackageCard 
            type="gold"
            title="Gold Package"
            price="₹2,999"
            features={[
              "Everything in Silver Package",
              "<span class='font-bold'>1-on-1 Session</span> with Career Expert",
              "Personalized Study Plan",
              "Institute Recommendations"
            ]}
            icon={<Crown className="h-8 w-8 text-amber-500" />}
            isPopular={true}
            onSelect={onPackageSelect}
          />
        </div>
      </div>
    </section>
  );
};

export default PackageSelection;
